/* Product pages disclose sold-out choices; product-card sliders stay intact. */
(() => {
  if (window.DGSoldOptionsReady) return;
  window.DGSoldOptionsReady = true;
  const groups = '.edition-options,.sf-options,[data-photo-segments]';
  const initialized = new WeakSet();
  function labels() {
    const copy = document.querySelector('[data-dg-sold-labels]')?.dataset || {};
    return {show:copy.show || 'Show [count] more · sold out online',hide:copy.hide || 'Hide sold-out options',sold:copy.sold || 'Sold out online'};
  }
  function choiceFor(node) { return node.matches('label') ? node.querySelector('input[name="id"]') : node; }
  function isSold(node) {
    const c = choiceFor(node);
    return !!c && (c.disabled || c.dataset.available === 'false' || c.dataset.photoAvailable === 'false' || c.getAttribute('aria-disabled') === 'true');
  }
  function describe(node) {
    const input = choiceFor(node);
    return input?.dataset.photoLabel || node.querySelector('.edition-tile > strong')?.textContent.trim() || node.getAttribute('title')?.split(' — ')[0] || node.textContent.trim();
  }
  function enhance(group) {
    if (initialized.has(group) || group.closest('.dg-sold-originals')) return;
    // Card sliders retain every option, including their existing faded sold-out controls.
    if (group.matches('.sf-options,[data-photo-segments]') || group.closest('.sf-card,.product-card')) return;
    const choices = [...group.children].filter(node => node.matches('.edition-option,[data-sf-variant],[data-photo-card-variant]'));
    const sold = choices.filter(isSold), available = choices.filter(node => !isSold(node));
    if (!sold.length || !available.length) return;
    initialized.add(group);
    const showDisclosure = !!group.closest('.product-page') && !group.closest('dialog,.sf-card,.product-card');
    const copy = labels(), details = document.createElement(showDisclosure ? 'details' : 'div');
    details.className = showDisclosure ? 'dg-sold-options' : 'dg-sold-compact';
    details.hidden = !showDisclosure;
    const summary = document.createElement('summary'), text = document.createElement('span');
    const collapsed = copy.show.replaceAll('[count]',String(sold.length));
    text.textContent = collapsed;
    summary.append(text);
    const list = document.createElement('ul');list.className = 'dg-sold-list';
    const originals = document.createElement('div');originals.className = 'dg-sold-originals';originals.hidden = true;
    const checkedSold = sold.some(node => choiceFor(node)?.checked);
    for (const node of sold) {
      if (showDisclosure) {
        const item = document.createElement('li'), title = document.createElement('strong'), status = document.createElement('span');
        title.textContent = describe(node);status.textContent = copy.sold;
        item.append(title,status);list.append(item);
      }
      const c = choiceFor(node);
      if (c.matches('input')) {c.disabled=true;c.checked=false;}
      originals.append(node);
    }
    if (showDisclosure) details.append(summary,list);
    details.append(originals);
    const container = group.closest('.sf-card-body') || group.parentElement;
    const select = container.querySelector('[data-sf-select]');
    if (select) {
      const soldIds = new Set(sold.map(n=>n.dataset.sfVariant));
      [...select.options].filter(option=>soldIds.has(option.value)).forEach(option=>option.remove());
      select.after(details);
    } else group.after(details);
    group.classList.add('dg-available-options');
    group.style.setProperty('--sf-count',available.length);
    group.style.setProperty('--photo-segments',available.length);
    // Keep the original tile width when unavailable editions move into the disclosure.
    group.style.setProperty('--edition-count',Math.min(Math.max(choices.length,2),5));
    const active = available.findIndex(n=>n.getAttribute('aria-pressed')==='true');
    group.style.setProperty('--sf-index',Math.max(0,active));
    group.style.setProperty('--photo-active-index',Math.max(0,active));
    if (showDisclosure) details.addEventListener('toggle',()=>{text.textContent=details.open?copy.hide:collapsed;});
    if (checkedSold) {
      const fallback = choiceFor(available[0]);
      if (fallback.matches('input')) {fallback.checked=true;queueMicrotask(()=>fallback.dispatchEvent(new Event('change',{bubbles:true})));}
    }
  }
  function init(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(groups)) enhance(root);
    root.querySelectorAll(groups).forEach(enhance);
  }
  function start() {
    init(document);
    new MutationObserver(records=>{
      for (const record of records) for (const node of record.addedNodes) init(node);
    }).observe(document.body,{childList:true,subtree:true});
  }
  document.addEventListener('shopify:section:load',event=>init(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
